import { Component, Vue } from 'vue-property-decorator'
import { findGoodsDisplayOrderByDealerId } from './gql'
import { TypedGqlError } from '@/interfaces/error'
import { showErrors } from '@/utils/snack'

@Component({
})

export default class DealerOrders extends Vue {
  // 查询的顺序数组id
  displayOrders: number[] = [];

  // 获取orders
  async getGoodsOrders () {
    const { id } = this.$route.params
    try {
      const result = await this.$apollo.query({
        query: findGoodsDisplayOrderByDealerId,
        variables: {
          dealerId: +id
        }
      })
      if (result) {
        this.displayOrders =
          result.data.findGoodsDisplayOrderByDealerId.displayOrders
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
